import Vue from "vue";
import Vuex from "vuex";
import firebase from "firebase";

Vue.use(Vuex);

export default {
  namespaced: true,
  state: {
    formTypes: [],
    forms: []
  },
  getters: {
    formTypes(state) {
      return state.formTypes;
    },
    forms(state) {
      return state.forms;
    }
  },
  actions: {
    getFormTypes({ commit, state }) {
      return new Promise((res, rej) => {
        const db = firebase.firestore();
        let formsRef = db.collection("forms");
        let formTypes = [];
        formsRef
          .get()
          .then(function(querySnapshot) {
            querySnapshot.forEach(function(doc) {
              // doc.data() is never undefined for query doc snapshots
              formTypes.push({ formId: doc.id, ...doc.data() });
              console.log("form id", doc.id);
            });
          })
          .catch(function(error) {
            console.log("Error getting tools documents: ", error);
          });
        commit("SET_FORM_TYPES", formTypes);
        res(formTypes);
      });
    },
    getFormsForType({ commit, state }, typeId) {
      let type = typeId;
      return new Promise((res, rej) => {
        const db = firebase.firestore();
        let formTypeRef = db.collection(`forms/${typeId}/items`);
        let forms = [];
        formTypeRef
          .get()
          .then(function(querySnapshot) {
            querySnapshot.forEach(function(doc) {
              forms.push({ formId: doc.id, ...doc.data() });
            });
          })
          .catch(function(error) {
            console.log("Error getting tools documents: ", error);
          });
        commit("SET_FORMS", { forms, typeId });
        res(forms);
      });
    },
    addForm({ commit, state }, { payload }) {
      return new Promise((res, rej) => {
        const db = firebase.firestore();
        let form = db.collection("forms").doc(payload.formDocumentName);
        form
          .set({
            name: payload.formFullName,
            type: payload.formType,
            _created_at: payload._created_at
          })
          .then(function() {
            res();
          })
          .catch(function(error) {
            console.log("Error getting tools documents: ", error);
          });
        // commit("SET_FORM_TYPES", formTypes);
      });
    }
  },
  mutations: {
    SET_FORM_TYPES(state, formTypes) {
      //console.log("formType", formTypes);
      if (formTypes) {
        state.formTypes = formTypes;
      } else {
        state.formTypes = [];
      }
    },
    SET_FORMS(state, { forms, typeId }) {
      if (forms) {
        state.forms[typeId] = forms;
      } else {
        state.forms[typeId] = [];
      }
    }
  }
};
